import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "whitespace-nowrap" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("wbr", null, null, -1)

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GtinString',
  props: {
    gtin: {},
    long: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const gtinString = computed(() => {
  if (props.long) {
    return `${props.gtin ?? "k.A."}`;
  } else {
    return props.gtin ?? "";
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createTextVNode(_toDisplayString(props.long ? "Gtin: " : ""), 1),
    _hoisted_2,
    _createTextVNode(_toDisplayString(gtinString.value), 1)
  ]))
}
}

})